<template>
  <Navbar />
  <main class="payment-container body" :dir="rtl ? 'rtl' : 'ltr'">
    <section class="payment-card">
      <h2>{{ $t('payment.title') }}</h2>
      <div class="form-group">
        <label>{{ $t('payment.date') }}</label>
        <input class="form-input" :value="date" readonly />
      </div>
      <div class="form-group">
        <label>{{ $t('payment.recipient') }}</label>
        <input class="form-input" :value="recipient" readonly />
      </div>
      <p v-if="resultMessage" class="notice" :class="resultSuccess ? 'success' : 'error'" role="status">
        {{ resultMessage }}
      </p>
      <button class="submit-btn" type="button" @click="showModal = true">
        {{ $t('payment.gatewayButton') }}
      </button>
    </section>

    <div v-if="showModal" class="modal-backdrop1" @click.self="closeModal">
      <section class="payment-modal" role="dialog" aria-modal="true" aria-labelledby="payment-modal-title">
        <h3 id="payment-modal-title">{{ $t('payment.gatewayButton') }}</h3>
        <form @submit.prevent="submitPayment">
          <div class="form-group">
            <label for="payment-amount">{{ $t('payment.amount') }} (ریال)</label>
            <input id="payment-amount" v-model="amount" class="form-input" type="number" min="1" step="1" required />
          </div>
          <div class="form-group">
            <label for="payment-order-id">شماره سفارش</label>
            <input id="payment-order-id" v-model="orderId" class="form-input" type="number" min="1" step="1" required />
          </div>
          <div class="form-group">
            <label for="payment-description">{{ $t('payment.reason') }}</label>
            <textarea id="payment-description" v-model="reason" class="form-input" rows="3"></textarea>
          </div>
          <p v-if="errorMessage" class="notice error" role="alert">{{ errorMessage }}</p>
          <div class="modal-actions">
            <button class="cancel-btn" type="button" :disabled="loading" @click="closeModal">انصراف</button>
            <button class="submit-btn" type="submit" :disabled="loading">
              {{ loading ? 'در حال اتصال…' : $t('payment.gatewayButton') }}
            </button>
          </div>
        </form>
      </section>
    </div>
  </main>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import moment from 'moment-jalaali'

const NOVIN_GATEWAY_URL = 'https://novin-sch.ir/gateway.php'

export default {
  name: 'PaymentPage',
  components: { Navbar },
  data() {
    return {
      date: '',
      recipient: 'حساب درگاه متصل',
      amount: '',
      orderId: '',
      reason: '',
      showModal: false,
      loading: false,
      errorMessage: '',
      resultMessage: '',
      resultSuccess: false,
    }
  },
  computed: {
    rtl() {
      return this.$i18n.locale === 'fa' || this.$i18n.locale === 'ar'
    },
  },
  mounted() {
    moment.loadPersian({ dialect: 'persian-modern' })
    this.date = moment().format('jYYYY/jMM/jDD')
    const callback = new URLSearchParams(window.location.search)
    const status = callback.get('gateway_status')
    if (status) {
      this.resultSuccess = status === 'success'
      this.resultMessage = callback.get('gateway_message') || (this.resultSuccess ? 'پرداخت موفق بود.' : 'پرداخت ناموفق بود.')
      window.history.replaceState({}, document.title, window.location.pathname)
    }
    this.orderId = String(Date.now())
  },
  methods: {
    closeModal() {
      if (!this.loading) {
        this.showModal = false
        this.errorMessage = ''
      }
    },
    async submitPayment() {
      this.loading = true
      this.errorMessage = ''
      try {
        const token = localStorage.getItem('token')
        if (!token) throw new Error('برای پرداخت ابتدا وارد حساب خود شوید.')
        const response = await fetch(NOVIN_GATEWAY_URL, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            amount: Number(this.amount),
            order_id: Number(this.orderId),
            description: this.reason,
          }),
        })
        const result = await response.json()
        if (!response.ok || !result.success) throw new Error(result.message || 'ایجاد درخواست پرداخت ناموفق بود.')

        const form = document.createElement('form')
        form.method = 'POST'
        form.action = result.data.payment_url
        const refId = document.createElement('input')
        refId.type = 'hidden'
        refId.name = 'RefId'
        refId.value = result.data.ref_id
        form.appendChild(refId)
        document.body.appendChild(form)
        form.submit()
      } catch (error) {
        this.errorMessage = error.message || 'ارتباط با درگاه برقرار نشد.'
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.payment-container {
  display: flex;
  justify-content: center;
  padding: 2rem;
  background: var(--bg);
  min-height: 100vh;
}
.payment-card, .payment-modal {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 2rem;
  width: 100%;
  max-width: 500px;
  box-shadow: var(--shadow);
}
.payment-card h2, .payment-modal h3 { text-align: center; color: var(--primary); margin: 0 0 20px; }
.form-group { margin-bottom: 15px; }
.form-group label { display: block; margin-bottom: 6px; color: var(--text); }
.form-input {
  box-sizing: border-box;
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--input-bg);
  color: var(--text);
}
.form-input:focus { outline: none; border-color: var(--primary); }
.submit-btn, .cancel-btn {
  padding: 10px 14px;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
}
.submit-btn { width: 100%; background: var(--primary); color: white; }
.submit-btn:hover:not(:disabled) { opacity: .9; }
.submit-btn:disabled, .cancel-btn:disabled { opacity: .65; cursor: wait; }
.cancel-btn { background: var(--border); color: var(--text); }
.modal-backdrop1 {
  position: fixed;
  z-index: 2000;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 1rem;
  background: rgb(0 0 0 / 55%);
}
.payment-modal { max-height: calc(100vh - 2rem); overflow-y: auto; }
.modal-actions { display: flex; gap: 10px; }
.modal-actions .submit-btn { flex: 1; }
.notice { padding: 10px 12px; border-radius: 6px; margin: 0 0 14px; }
.success { color: #176b37; background: #e8f7ed; }
.error { color: #982b2b; background: #fdecec; }
</style>
